import React from "react";
import { BRAND } from "../../lib/brand";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";

export const Contact = () => (
  <section id="contact" className="relative bg-[#7CB518] text-black section-divider">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.85]">
            Got Junk?<br />Let's Get<br />Rid Of It.
          </h2>
          <a
            href={BRAND.phoneHref}
            data-testid="contact-call-btn"
            className="press inline-flex items-center gap-2 mt-8 bg-black text-[#7CB518] font-display uppercase text-lg px-8 py-4 border-2 border-black hard-shadow-black"
            style={{ boxShadow: "6px 6px 0 0 #0a0a0a" }}
          >
            Call / Text Us <ArrowRight size={20} />
          </a>
        </div>

        <div className="space-y-4">
          <a href={BRAND.phoneHref} data-testid="contact-phone" className="press flex items-center gap-4 bg-black text-white p-5 border-2 border-black">
            <Phone className="text-[#7CB518]" size={26} />
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50">Call / Text</div>
              <div className="font-display text-2xl">{BRAND.phone}</div>
            </div>
          </a>
          <a href={`mailto:${BRAND.email}`} data-testid="contact-email" className="press flex items-center gap-4 bg-black text-white p-5 border-2 border-black">
            <Mail className="text-[#7CB518]" size={26} />
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50">Email</div>
              <div className="font-display text-xl break-all">{BRAND.email}</div>
            </div>
          </a>
          <div className="flex items-center gap-4 bg-black text-white p-5 border-2 border-black">
            <MapPin className="text-[#7CB518]" size={26} />
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50">Service Area</div>
              <div className="font-display text-xl">{BRAND.area}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
